import React from "react";

type ResearchItemProps = {
  dateLabel: string;
  imageUrl: string;
  title: string;
  authors: string;
  meta: string;
  link: string;
};

const ResearchItem: React.FC<ResearchItemProps> = ({
  dateLabel,
  imageUrl,
  title,
  authors,
  meta,
  link,
}) => {
  return (
    <section className="w-full">
      <div className="text-valpeacock uppercase tracking-wide text-[18px] font-medium">
        {dateLabel}
      </div>

      <div className="h-px w-full bg-valpeacock mt-3 mb-8" />

      <div className="flex flex-col md:flex-row gap-8">
        <div className="w-full md:w-[340px] shrink-0">
          <div className="border border-valpeacock bg-white p-2">
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="block">
              <img
                src={imageUrl}
                alt={title}
                className="w-full h-auto cursor-pointer"
              />
            </a>
          </div>
        </div>

        <div className="flex-1">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
            <h2 className="text-valmidnight font-semibold text-[28px] leading-snug">
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline">
                {title}
              </a>
            </h2>
          </div>

          <div className="mt-4 text-[16px] text-gray-800">{authors}</div>

          <div className="mt-4 text-[16px] text-gray-800">{meta}</div>
          <div className="mt-4 text-[16px] text-gray-800">
            Epublished DOI: 10.1016/j.jacadv.2025.102552
          </div>
        </div>
      </div>
    </section>
  );
};
export default ResearchItem;
